<canvas
  id="background-images"
  aria-label="Imagens dos projetos desenhados pela MADESI"
  role="img"
></canvas>
